// extracted by mini-css-extract-plugin
module.exports = {"bold":"Bold_bold__2bPRv"};